import {Group} from '@visx/group';
import React from 'react';

import {PolymerLayout} from 'constants/MapsConstants';

/**
 * Wraps contents to render for React views to render on a linear sequence map slice.
 *
 * @param children Elements to render
 * @param layout Parameters describing where to render the view in relation to the slice.
 * @param shouldStopMouseDownPropagation Whether to prevent propagation of mouseDown events and stop default
 * sequence map click behavior. Children of ComponentWrapper should not have their own mouse/click handlers
 * stopping propagation since this will break sequence map focus behavior, affecting copying, selections, etc.
 */
export default function ComponentWrapper({
  children,
  layout,
  shouldStopMouseDownPropagation,
}: {
  children: JSX.Element;
  layout: PolymerLayout;
  shouldStopMouseDownPropagation: boolean;
}): JSX.Element {
  function handleMouseEventPropagation(e: React.MouseEvent): void {
    if (shouldStopMouseDownPropagation) {
      e.stopPropagation();
      // Some views have their own click behavior that should not propogate up to also trigger
      // SliceView's generic mousedown logic, but we do still want to put focus on the sequence map on click.
      $(e.target).closest('.buffer-tab').focus();
    }
    // In order to preserve the correct selection states, do not fire a focus event on the clicked element
    // and keep the focus on the clicked buffer tab.
    // SliceView.focusableParent will still refocus to the correct div, but the brief moment
    // this element is focused will show a flicker of the default Chrome focused element outline style.
    e.preventDefault();
  }

  return (
    <Group
      className="component-wrapper"
      top={layout.vMargin}
      onMouseDown={handleMouseEventPropagation}
      onDoubleClick={handleMouseEventPropagation}
    >
      {children}
    </Group>
  );
}
